import { useAppSelector } from "@hooks";
import { LinearProgress } from "@mui/material";
import { Box } from "@mui/system";

const PageLoader = () => {
  const loader = useAppSelector((state) => state.common.loader) as any;

  return (
    loader && (
      <Box
        sx={{
          position: "fixed",
          zIndex: 99999,
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255,255,255,0.6)",
        }}
      >
        <LinearProgress sx={{ height: 10 }} color="primary" />
      </Box>
    )
  );
};

export default PageLoader;
